module.exports = __webpack_public_path__ + "img/align_center.30b8c650.svg";